/**
 * Backend serial id for table "ID" columns (`sr_id`, camelCase, or legacy `serial_id`).
 */
export function readSrIdFromUnknown(source: unknown): string | undefined {
  if (!source || typeof source !== "object") return undefined;
  const o = source as Record<string, unknown>;
  const v = o.sr_id ?? o.srId ?? o.serial_id;
  if (v == null || v === "") return undefined;
  const s = String(v).trim();
  return s || undefined;
}
